import classNames from "classnames"

export type PricingSummaryRowProps = {
  title?: string
  titleValue?: string
  subtitle?: string
  subtitleValue?: string
  highlight?: boolean
  className?: string
}

export const PricingSummaryRow = ({
  title,
  titleValue,
  subtitle,
  subtitleValue,
  highlight,
  className,
}: PricingSummaryRowProps) => {
  return (
    <>
      {(title || titleValue) && (
        <div className={classNames("mb-4 w-full", className)}>
          <div
            className={classNames("flex justify-between", {
              "font-semibold": highlight,
            })}
          >
            <span>{title}</span>
            <span className="whitespace-nowrap">{titleValue}</span>
          </div>

          {(subtitle || subtitleValue) && (
            <div className="mt-2 flex justify-between text-sm text-gray-400">
              <span>{subtitle}</span>
              <span className="whitespace-nowrap">{subtitleValue}</span>
            </div>
          )}
        </div>
      )}
    </>
  )
}
